export const shadows = {
  subheader: '0px 3px 2px rgba(0, 0, 0, 0.06)',
  focusVisible: '0 0 0pt 2pt rgba(11, 153, 230, 0.4)',
};
